import {gql} from '@apollo/client';

const FRAGMENT_INTEREST_LIST = gql`
  fragment InterestList on InterestType {
    id
    themeId
  }
`;

export const QUERY_INTEREST_LIST = gql`
  query InterestList {
    interestList {
      ...InterestList
    }
  }
  ${FRAGMENT_INTEREST_LIST}
`;

export const MUTATION_INTEREST_SAVE = gql`
  mutation InterestSave($input: InterestSaveInput!) {
    interestSave(input: $input) {
      obj {
        ...InterestList
      }
    }
  }
  ${FRAGMENT_INTEREST_LIST}
`;

export const MUTATION_INTEREST_DELETE = gql`
  mutation InterestDelete($input: InterestDeleteInput!) {
    interestDelete(input: $input) {
      obj {
        id
      }
    }
  }
`;
